import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import AbstractSliderControl from "slotworks/smart-ui/controls/abstract/abstract-slider-control";
import { Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { arrayOfValues } from "slotworks/utils/collection-utils";
import { formatPercentage } from "slotworks/utils/string-formatters";

export default class VolumeSliderControl extends AbstractSliderControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.formatFunction = formatPercentage;
        this.sliderComponent.onChange.add(this.onChangeHandler);
        this.sliderComponent.onInput.add(this.onChangeHandler);

        const values: number[] = arrayOfValues<number>(101);
        super.setupData(values, Services.sound.getVolume() * 100);

        Services.sound.onMuteChange.add(this.muteUpdated);
    }

    public destroy() {
        Services.sound.onMuteChange.remove(this.muteUpdated);

        super.destroy();
    }

    protected onChangeHandler = (value: number) => {
        Services.sound.setVolume(value * 0.01);
        this.setSliderIndex(value);
        if (value === 0) {
            Services.sound.mute();
        } else {
            Services.sound.unmute();
        }
    }

    private muteUpdated = () => {
        let sliderIndex = 0;
        if (!Services.sound.getMuted()) {
            sliderIndex = Services.sound.getVolume() * 100;
        }
        this.setValueLabel(sliderIndex);
        this.setSliderIndex(sliderIndex);
    }
}
